var _circle, _rect, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsetAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_6141)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 19.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_6141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -6,
    width: 70,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 69.5,
    height: 69.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_6141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.48 35.3374L17.3852 28.2426C16.9508 27.8082 16.4199 27.591 15.7924 27.591C15.165 27.591 14.61 27.8323 14.1273 28.315C13.693 28.7494 13.4758 29.2803 13.4758 29.9077C13.4758 30.5351 13.693 31.066 14.1273 31.5004L22.9596 40.4051C23.394 40.8395 23.9008 41.0566 24.48 41.0566C25.0591 41.0566 25.5659 40.8395 26.0003 40.4051L43.3029 23.1025C43.7855 22.6198 44.0268 22.0648 44.0268 21.4374C44.0268 20.8099 43.7855 20.2549 43.3029 19.7723C42.8202 19.3379 42.2531 19.1328 41.6016 19.1569C40.95 19.181 40.407 19.4103 39.9727 19.8447L24.48 35.3374ZM28.7513 57.7077C24.7937 57.7077 21.0532 56.9475 17.5299 55.4272C14.0067 53.9069 10.9299 51.8316 8.29948 49.2012C5.6691 46.5708 3.59375 43.494 2.07344 39.9707C0.553125 36.4474 -0.207031 32.707 -0.207031 28.7494C-0.207031 24.7434 0.553125 20.9789 2.07344 17.4556C3.59375 13.9323 5.6691 10.8676 8.29948 8.26133C10.9299 5.65508 14.0067 3.5918 17.5299 2.07148C21.0532 0.551172 24.7937 -0.208984 28.7513 -0.208984C32.7572 -0.208984 36.5218 0.551172 40.0451 2.07148C43.5683 3.5918 46.6331 5.65508 49.2393 8.26133C51.8456 10.8676 53.9089 13.9323 55.4292 17.4556C56.9495 20.9789 57.7096 24.7434 57.7096 28.7494C57.7096 32.707 56.9495 36.4474 55.4292 39.9707C53.9089 43.494 51.8456 46.5708 49.2393 49.2012C46.6331 51.8316 43.5683 53.9069 40.0451 55.4272C36.5218 56.9475 32.7572 57.7077 28.7513 57.7077Z",
    fill: "#266800"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_6141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsetAccepted);
export default __webpack_public_path__ + "static/media/ConsetAccepted.bc40284d358e64d0bce13b75f06eb7c1.svg";
export { ForwardRef as ReactComponent };